import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemBookingInfoComponent } from '../../components/item-booking-info/item-booking-info.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-booking-info',
	templateUrl: './modal-booking-info.component.html',
	imports: [ CommonModule, TranslatePipe, ItemBookingInfoComponent, FormsModule ]
})
export class ModalBookingInfoComponent implements OnInit {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalBookingInfoComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	@Input() booking: any;
	@Input() showPrescription: any;

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.booking = this.angularHelperService.copy(this.vm.booking) || {};
		this.vm.original = this.booking;
		this.vm.close = this.close;
	}
	
	close = () => {
		this.dialogRef.close();
	}
	
}